import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import withMatchMediaProps from "@hocs/with-match-media-props";
import ProductItem from "./ProductItem";
import { injectIntl } from "react-intl";
import Breadcrumb from "./Breadcrumb";
import SearchBar from "./SearchBar";
import { searchProducts } from "actions/marketplaceActions";
import { withRouter } from "react-router-dom";
import { Button, Loader } from "cxa-components";
import messages from "components/messagesDescription";

const SearchResultPage = ({ searchResults, searchProducts, isFetching, intl, ...props }) => {
  const loadMoreProducts = () => {
    !isFetching && searchProducts(searchResults.params, true);
  };

  return (
    <div className="marketplace-container">
      <SearchBar {...props} />
      <Breadcrumb
        intl={intl}
        pageLabel={intl.formatMessage(messages.marketplace.searchResultsLabel)}
      />
      {isFetching && <Loader />}
      {!isFetching && searchResults.data.length <= 0 && (
        <div style={{ padding: "10px" }}>
          <strong> {intl.formatMessage(messages.marketplace.searchNoOffersDescription)}</strong>
        </div>
      )}
      {searchResults.data.length > 0 && (
        <div className="product-list-container">
          <div className="card-container">
            {searchResults.data.map(item => {
              return <ProductItem key={item.productId} product={item} />;
            })}
          </div>
          {searchResults.showMore && (
            <Button onClick={loadMoreProducts} primary className="load-more-btn">
              {intl.formatMessage(messages.marketplace.seeMoreLabel)}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

SearchResultPage.propTypes = {
  searchResults: PropTypes.object,
  intl: PropTypes.object,
  searchProducts: PropTypes.func,
  isFetching: PropTypes.bool,
};

const mapStateToProps = ({ marketplace: { searchResults, isFetching } }) => ({
  searchResults,
  isFetching,
});
const mapDispatchToProps = {
  searchProducts,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(SearchResultPage))));



// WEBPACK FOOTER //
// ./components/marketplace/SearchResultPage.jsx